import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import OrdersList from "@/pages/OrdersList";
import OrderDetail from "@/pages/OrderDetail";
import ReadyToShip from "@/pages/ReadyToShip";
import Inventory from "@/pages/Inventory";
import BatchOrders from "@/pages/BatchOrders";
import Billing from "@/pages/Billing";
import Users from "@/pages/Users";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Report from "@/pages/Report";
import Claims from "@/pages/Claims";
import AiInbox from "@/pages/AiInbox";
import RushQueue from "@/pages/RushQueue";
import ThreePL from "@/pages/ThreePL";
import Installers from "@/pages/Installers";

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Private>
            <Layout />
          </Private>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="customers" element={<Customers />} />
        <Route path="orders/ready-to-ship" element={<ReadyToShip />} />
        <Route path="orders/:stage" element={<OrdersList />} />
        <Route path="order/:id" element={<OrderDetail />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="batch-orders" element={<BatchOrders />} />
        <Route path="billing" element={<Billing />} />
        <Route path="users" element={<Users />} />
        <Route path="team" element={<Team />} />
        <Route path="settings" element={<Settings />} />
        <Route path="report" element={<Report />} />
        <Route path="claims" element={<Claims />} />
        <Route path="installers" element={<Installers />} />
        <Route path="rush" element={<RushQueue />} />
        <Route path="three-pl" element={<ThreePL />} />
        <Route path="ai-inbox" element={<AiInbox />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
